// Clase compartida por expendedoras y tanques para modificar su estado de servicio

export class EstadoServicio {
    estado: number;
    fechaHoraUltimoCambio: string;
    responsable: string;
    fechaHoraFS: string;
    observaciones: string;
}